import React from "react";

export const CommunityInsightsDisclaimer = () => {
    return (
        <div className="text-sm text-gray-500">
            Pricing and availability are provided by community operators and may change.
            Please verify directly with the community in your selection process.
        </div>
    );
};
